// navigation.js
let navigateFn = null;

export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

export const navigate = (...args) => {
  if (navigateFn) {
    navigateFn(...args);
  } else {
    // fallback or error handling
    console.warn('Navigate function not set');
  }
};